<script>
export default {
  name: "HomeKpi",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    currency: {
      type: Boolean,
      default: false
    },
    points: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "bx-dollar"
    },
    accentColor: {
      type: String,
      default: "#1B3AE8"
    },
    badge: {
      // { text, variant: 'success' | 'warning' | 'danger' }
      type: Object,
      default: null
    },
    helperText: {
      type: String,
      default: ""
    },
  },
  computed: {
    displayValue() {
      if (this.currency) return this.$options.filters.currency(this.value);
      if (this.points) return this.$options.filters.points(this.value);
      return this.value;
    }
  }
};
</script>

<template>
  <div class="card home-kpi" :style="{ borderLeftColor: loading ? '#e5e7eb' : accentColor }">
    <div class="card-body">
      <template v-if="loading">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="skeleton-block" style="width: 120px; height: 10px;"></span>
        </div>

        <div class="home-kpi-value mb-2">
          <span class="skeleton-block" style="width: 100px; height: 24px;"></span>
        </div>

        <span class="skeleton-block skeleton-pill" style="width: 80px; height: 18px;"></span>
      </template>

      <template v-else>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="text-muted font-size-12 font-weight-semibold text-uppercase">{{ title }}</span>
        </div>

        <div class="home-kpi-value notranslate mb-2">{{ displayValue }}</div>

        <div v-if="badge" class="badge-pill" :class="'badge-pill-' + badge.variant">
          {{ badge.text }}
        </div>
        <div v-else-if="helperText" class="badge-pill">{{ helperText }}</div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.home-kpi {
  border-left-width: 4px;
  border-left-style: solid;
  height: calc(100% - 24px);
}

.home-kpi-icon {
  width: 32px;
  height: 32px;
  background-color: rgba(112, 42, 42, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.home-kpi-value {
  font-size: 28px;
  font-weight: 600;
  line-height: 1;
}

.badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background-color: #e7e7e7;
  color: #0a0a0a;
}

.badge-pill-success {
  background-color: #ecfdf5;
  color: #065f46;
}

.badge-pill-warning {
  background-color: #fffbeb;
  color: #92400e;
}

.badge-pill-danger {
  background-color: #fef2f2;
  color: #991b1b;
}

.home-kpi-total {
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.home-kpi-total-value {
  font-size: 16px;
  font-weight: 600;
}

.skeleton-block {
  display: inline-block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef0f2 25%, #e2e4e7 37%, #eef0f2 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

.skeleton-pill {
  border-radius: 999px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
